var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Heading Text 🍇 🥕")]),_vm._t("body",[_vm._v("\n        lorem deka ✒️ 🍇\n    ")]),_vm._t("panel"),_vm._t("default",[_vm._v("boxy")]),_c('h2',[_vm._v("Footer Text")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }